// extracted by mini-css-extract-plugin
module.exports = {"accountName":"accountName__1-mtm","label":"label__38Ami","text":"text__eThpv"};